export const firebaseConfig = {
  apiKey: "AIzaSyCzVKJf4uOyQxyWYaLD39pkd0_Up2u2gnY",
  authDomain: "linked-in-clone-464d9.firebaseapp.com",
  projectId: "linked-in-clone-464d9",
  storageBucket: "linked-in-clone-464d9.appspot.com",
  messagingSenderId: "854248874047",
  appId: "1:854248874047:web:a3295eef90c80aec7b988a",
};
